import useUserPermissions from "../../../../../common/utils/user/permissions/use-user-permissions";
import taxiListingUserPermissionDefinition from "./taxi-listing-user-permission";

const useTaxiListingUserPermissions = () => {
  return useUserPermissions(taxiListingUserPermissionDefinition);
};

export default useTaxiListingUserPermissions;
